import { toNumber } from '@/lib/decimal'
import { type PlanningCell, STAGE_BANDS } from '@/lib/planning-types'
import { cn } from '@/lib/utils'
import { BAND_FILL, BAND_LABEL } from './CapacityBar'
import { STAGE_FILTERS } from './stages'

const CHOSEN = new Set(STAGE_FILTERS.map((filter) => filter.band))

/**
 * Wat de knoppenrij boven de kolommen niet uitlegt. De vier zekerheidstrappen
 * dragen hun blokje daar al, en dezelfde uitleg twee keer op een kaart zetten is
 * twee plekken om te kijken voor dezelfde vraag.
 *
 * Wat overblijft is de arcering: omvang die wel is opgegeven maar nog in geen
 * enkele maand staat. Dat is geen trap die je aan of uit zet maar een andere as,
 * en dus de enige band die zichzelf hier moet verklaren - en alleen als hij er
 * ook echt staat, want een rustig kwartaal hoort geen begrip te introduceren dat
 * er niet is.
 */
export function PlanningLegend({ months }: { months: PlanningCell[] }) {
  const present = STAGE_BANDS.filter(
    (band) => !CHOSEN.has(band) && months.some((month) => toNumber(month.byStage[band]) > 0),
  )
  if (present.length === 0) return null

  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-2 border-t border-hairline px-5 py-3 text-xs text-ink-faint">
      {present.map((band) => (
        <span key={band} className="inline-flex items-center gap-1.5">
          <span aria-hidden className={cn('h-2 w-2 rounded-xs', BAND_FILL[band])} />
          {BAND_LABEL[band]} · staat nog in geen enkele maand
        </span>
      ))}
    </div>
  )
}
